var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgArrowNextStep = function SvgArrowNextStep(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5C12 4.83509 11.9354 4.68338 11.8061 4.55805L7.52181 0.197889C7.37964 0.0527705 7.24394 0 7.08885 0C6.77221 0 6.52666 0.237467 6.52666 0.567282C6.52666 0.725594 6.57835 0.877309 6.68174 0.98285L8.12924 2.48681L10.3005 4.51187L8.74313 4.41293H0.568659C0.232633 4.41293 0 4.65699 0 5C0 5.34301 0.232633 5.58707 0.568659 5.58707H8.74313L10.3069 5.48813L8.12924 7.51319L6.68174 9.01715C6.57835 9.1161 6.52666 9.27441 6.52666 9.43272C6.52666 9.76253 6.77221 10 7.08885 10C7.24394 10 7.37964 9.94063 7.50888 9.8153L11.8061 5.44195C11.9354 5.31662 12 5.16491 12 5Z",
    fill: "#1C1C1E"
  })));
};
export default SvgArrowNextStep;